import { ExplainerVideo } from '@/types/explainer-video.types';

export const explainerVideos: ExplainerVideo[] = [
	{
		slug: 'what-is-a-fractional-cto',
		title: 'What a Fractional CTO Actually Does',
		description:
			"If technology feels like something you're constantly putting out fires on instead of relying on, a fractional CTO is the fix. I step in part time, evaluate what you've got, and personally build and maintain the systems, so tech stops being the thing eating your week.",
		embedUrl: 'https://www.youtube-nocookie.com/embed/SjFuYtmTCoU',
		thumbnail: 'https://i.ytimg.com/vi/SjFuYtmTCoU/hqdefault.jpg',
	},
	{
		slug: 'what-you-stop-worrying-about',
		title: 'What You Stop Having to Worry About',
		description:
			"You don't need to understand any of this yourself, that's the whole point of bringing in a fractional CTO. I take on the tech decisions, the maintenance, and the planning, so it's finally off your plate instead of something you're guessing your way through.",
	},
	{
		slug: 'what-this-looks-like-in-practice',
		title: 'What This Looks Like In Practice',
		description:
			"A walkthrough of how the work actually unfolds — starting with a tech audit, moving into a prioritized roadmap, and settling into a steady monthly rhythm of builds and check-ins.",
	},
];
